<!-- 屹诚销售退货订单模板 -->
<template>
    <div v-loading="loading">
        <div id="printYCSaleReturn" class="print-zone">
            <div style="width: 763px; margin: 0 auto">
                <div id="top">
                    <div class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : "销售退货单"  }}</div>
                    <div class="order-detail">
                        <div>退货单号：{{ orderData.ReturnCode }}</div>
                        <div>
                            退货日期：
                            <el-date-picker
                                v-show="isEditOpenTime"
                                v-model="orderData.ReturnTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetime"
                                size="small"
                                placeholder="选择日期时间"
                            ></el-date-picker>
                            <span v-show="!isEditOpenTime">{{ orderData.ReturnTime }}</span>
                        </div>
                    </div>
                </div>
                <div id="top1">
                    <div class="print-table-main">
                        <div class="div-table-row">
                            <div class="div-table-cell" style="width: 21%">客户名称</div>
                            <div class="div-table-cell fdzt" style="width: 79%">{{ orderData.EntpCusName }}</div>
                        </div>
                        <div class="div-table-row">
                            <div class="div-table-cell" style="width: 21%">客户地址</div>
                            <div class="div-table-cell" style="width: 79%">{{ orderData.FullAddress }}</div>
                        </div>
                    </div>
                </div>
                <div id="table">
                    <table border="1" cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse; table-layout: fixed" bordercolor="#333333">
                        <thead>
                            <tr style="font-weight: bold">
                                <td width="20%">
                                    <div><b>汽配编码</b></div>
                                </td>
                                <td width="10%">
                                    <div><b>互换码</b></div>
                                </td>                                
                                <td width="15%">
                                    <div><b>配件名称</b></div>
                                </td>
                                <td width="19%">
                                    <div><b>车型</b></div>
                                </td>
                                <td width="6%">
                                    <div><b>数量</b></div>
                                </td>
                                <td width="8%">
                                    <div><b>品牌</b></div>
                                </td>
                                <td width="6%">
                                    <div><b>单位</b></div>
                                </td>
                                <td width="7%">
                                    <div><b>退单价</b></div>
                                </td>
                                <td width="9%">
                                    <div><b>退单总价</b></div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="index" v-for="(AP, index) in orderData.DetailList">
                                <td>{{ AP.APCode }}</td>
                                <td style="white-space: pre-wrap;word-wrap: break-word;word-break: break-all">{{ AP.GoodCode }}</td>
                                <td>{{ AP.GoodName }}</td>
                                <td>{{ AP.AutoSerise }}</td>
                                <td>{{ AP.ReturnCount }}</td>
                                <td>{{ AP.Brand }}</td>
                                <td>{{ AP.Unit }}</td>
                                <td>{{ AP.ReturnPrice }}</td>
                                <td>{{ AP.ReturnCount * AP.ReturnPrice }}</td>

                            </tr>
                            <tr>
                                <td colspan="4" align="right">
                                    <div><b>总数量：</b></div>
                                </td>
                                <td>{{ orderData.TotalCount }}</td>
                                <td colspan="2" align="right">
                                    <div><b>总价：</b></div>
                                </td>
                                <td></td>
                                <td>{{ orderData.TotalRetrunAmount }}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <div id="foot">
                    <div class="order-detail">
                        <div>退款方式：{{ orderData.PayTypeName }}</div>
                        <div>退款金额：{{ orderData.Paid }}</div>
                    </div>
                    <div class="order-remark">
                        <div>退货原因：{{ orderData.Reasons }}</div>
                    </div>
                    <!--    脚注    -->
                    <div
                        class="order-remark"
                        v-if="(config == null ? false : config.Result && !isEditConfig) || orderData.IsHaveTitleSet"
                        v-html="orderData.IsHaveTitleSet ? orderData.FootNote.replace(/\n/g, '<br/>') : config.RValue.replace(/\n/g, '<br/>')"
                    ></div>
                    <div class="order-setcontent" v-if="isEditConfig">
                        <el-input type="textarea" resize="auto" rows="3" v-model="config.RValue"></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <!--   脚注   -->
                <div class="re-set">
                    <el-button class="btn-primary" @click="setConfig()" v-if="config == null ? false : config.Result && !isEditConfig && !orderData.IsHaveTitleSet"
                        >备注</el-button
                    >
                    <el-button class="btn-primary" @click="submitConfig()" v-if="isEditConfig">保存备注</el-button>
                </div>
                <!--   开单时间   -->
                <div class="open-time">
                    <el-button class="btn-primary" @click="setOpenTime()" v-if="openTimeConfig && openTimeConfig.Result && !isEditOpenTime">设置开单时间</el-button>
                    <el-button class="btn-primary" @click="submitOpenTime()" v-if="isEditOpenTime">保存开单时间</el-button>
                </div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printYCSaleReturn'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: false,
            allPrice: 0,
            allNum: 0,
            company: userMsg.EntpName,
            permission: {},
            openTimeConfig: null, // 开单时间配置
            isEditOpenTime: false, // 编辑开单时间
            config: null, // 脚注配置
            isEditConfig: false, // 编辑脚注
            entpId: userMsg.EntpId,
            isPrint: false,
            isPreview: false,
            isDefaultSet: false,
            orderData: {}
        };
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.orderData = {};
            this.getConfigByCodes().then(() => {
                this.getSaleOrder();
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyyl', 'syllqdysz', 'dyxsthsj', 'dyxsth'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                                case 'dyxsthsj':
                                    this.openTimeConfig = data[i];
                                    break;
                                case 'dyxsth':
                                    this.config = data[i];
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let topStyle = `
                        .print-title-view {
                            width: 762px;
                            position: relative;
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-end;
                            padding: 12px 0;
                            margin-top: 30px;
                        }
                        .print-title {
                            text-align: center;
                            font-size: 20px;
                            font-weight: bold;
                            color: #000;
                        }
                        .print-table-main {
                            margin-left: 3px;
                            font-size: 12px;
                            margin-right: -2px;
                        }
                        .print-table-main .div-table-cell {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            height: auto;
                            line-height: 25px;
                            padding-left: 10px;
                            border-top: 1px dotted #000;
                            border-right: 1px dotted #000;
                            border-bottom: 1px dotted #000;
                            color: #000;
                        }
                        .print-table-main .div-table-row {
                            border-left: 1px dotted #000;
                        }
                        #barcode {
                            display: none;
                        }

                        .order-detail {
                            display: -webkit-flex;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-left: 10px;
                            margin-right: 10px;
                            padding: 2px 0;
                            color: #000;
                        }

                        .re-submit {
                            text-align: right;
                        }

                        .print-zone {
                            width: 200mm;
                        }

                        .div-table-cell {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            height: 25px;
                            line-height: 25px;
                            padding-left: 10px;
                            border-top: 1px solid #000;
                            border-right: 1px solid #000;
                            color: #000;
                        }
                        .div-table-row {
                            display: flex;
                            border-left: 1px solid #000;
                            margin: 0;
                            font-size: 14px;
                        }

                        .btn-ctn-left {
                            display: flex;
                        }
                        .fdzt {
                            font-size: 14px;
                        }
                        .sort-set {
                            margin-left: 10px;
                        }
                        .btn-primary {
                            background: #ff9900;
                            color: white;
                            margin-left: 0px;
                        }
                        .order-picking {
                            margin-right: 80px;
                        }
               `;
                var tableStyle = `
                    table,
                    td,
                    th {
                        border-width: 1px;
                        border-style: dotted !important;
                        border-top-style: none;
                        border-collapse: collapse;
                        color: #000;
                        padding-bottom: 3px;
                        padding-top: 3px;
                        padding-left: 2px;
                    }              
                    table{
                        border-bottom: 0px;
                        border-left: 0px;
                        border-right: 0px;                       
                    }
                    td {
                        white-space: nowrap;
                        text-overflow: clip;
                        overflow: hidden;
                    }
                    tfoot td {
                        font-weight: bold;
                        border: 0;
                    }
                                     
                `;

                let footStyle = `
                    .order-detail {
                        display: -webkit-flex;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        margin-left: 10px;
                        margin-right: 10px;
                        padding: 2px 0;
                        color: #000;
                    }
                    .order-remark {
                        display: -webkit-flex;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        margin-left: 10px;
                        margin-right: 10px;
                        padding: 0px 0px 15px 0px;
                        color: #000;
                    }                

                    .fwb {
                        font-weight: bold;
                    }
                    .btd {
                        border-bottom: 1px dashed #000;
                        font-weight: bold;
                    }                                
                `;

                LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);
                let contentHeight = document.getElementById('printYCSaleReturn').clientHeight;
                let topHeight = document.querySelector('#printYCSaleReturn #top').clientHeight + document.querySelector('#printYCSaleReturn #top1').clientHeight;
                let topHeight0 = document.querySelector('#printYCSaleReturn #top').clientHeight;
                let tableHeight = document.querySelector('#printYCSaleReturn #table').clientHeight;
                let footHeight = document.querySelector('#printYCSaleReturn #foot').clientHeight;

                if (contentHeight <= 1080) {
                    // 这里3表示纵向打印且纸高“按内容的高度”；
                    // LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', '');
                    // 纵向打印，固定纸张；
                    LODOP.SET_PRINT_PAGESIZE(1, '210mm', '93.1mm', '');
                    //隐藏页尾
                    tableStyle += 'tfoot{display:none;}';
                }

                LODOP.ADD_PRINT_HTM('5', '0', '100%', '100%', `<!DOCTYPE html><style>${topStyle}</style>` + document.querySelector('#printYCSaleReturn #top').innerHTML);
                LODOP.ADD_PRINT_HTM(topHeight0 + 5, '0', '100%', '100%', `<style>${topStyle}</style>` + document.querySelector('#printYCSaleReturn #top1').innerHTML);
                LODOP.ADD_PRINT_TABLE(
                    topHeight + 6,
                    0,
                    '100%',
                    `BottomMargin:1px`,
                    `<style>${tableStyle}</style>` + document.querySelector('#printYCSaleReturn #table').innerHTML
                );

                //次页开始的上边距偏移量
                LODOP.SET_PRINT_STYLEA(0, 'Offset2Top', -topHeight - 3);

                if (footHeight > 0) {
                    LODOP.ADD_PRINT_HTM('0', '0', '100%', footHeight, `<style>${footStyle}</style>` + document.querySelector('#printYCSaleReturn #foot').innerHTML);
                    LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', -1);
                }

                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({ OrderId: this.printIds[0], Type: 9 }, false)
                .then(() => {
                    this.isPrint = true;
                    this.loading = false;
                    if (!this.isInit) this.$emit('closeDialog', true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 取消
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        // 获取表格
        getSaleOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleReturnOrder/GetOrderDetailForPrint',
                    data: {
                        SReturnId: this.printIds[0]
                    },
                    hideLoading: this.isInit
                })
                .then(res => {
                    let data = res.data;
                    this.orderData = res.data;
                    let that = this;
                    if (that.isInit) that.loading = false;
                    else {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                that.lodopPrint();
                            }, 100);
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        setOpenTime() {
            this.isEditOpenTime = true;
        },
        submitOpenTime() {
            this.isEditOpenTime = false;
        },
        setConfig() {
            this.isEditConfig = true;
        },
        // 提交脚注
        submitConfig() {
            if (!this.config.RValue || !this.config.RValue.trim()) {
                this.$message.error('请输入备注');
                return;
            }
            this.loading = true;
            this.isEditConfig = false;
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/UpdateSysConfigResultsById',
                    data: {
                        EntpId: this.entpId,
                        ConfigId: this.config.ConfigId,
                        RValue: this.config.RValue
                    },
                    hideLoading: true
                })
                .then(() => {
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped media="print">
.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}
.print-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
}
.order-detail {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 2px 0;
    color: #000;
}
.print-table-main {
    margin-left: 1px;
    font-size: 12px;
    margin-right: -1px;
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 25px;
        padding-left: 10px;
        border-top: 1px dotted #000;
        border-right: 1px dotted #000;
        border-bottom: 1px dotted #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px dotted #000;
    }
}
.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 0px 0px 15px 0px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}

.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.btn-ctn-left {
    display: flex;
}

table,
td,
th {
    border-width: 1px;
    border-style: dotted;
    border-top-style: none;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
}
td {
    white-space: nowrap;
    text-overflow: clip;
    overflow: hidden;
}
tfoot {
    display: none;
}
</style>
